import { useEffect } from "react";

import { useCookieConsent } from "@/hooks/useCookieConsent";
import { useGlobalContext } from "@/hooks/useGlobalContext";
import { initializeAdsMeasurement, setAdsMeasurementEnabled } from "@/lib/adsMeasurement";

export function AdsMeasurementPixel({ pixelId, debug }: { pixelId: string; debug: boolean }) {
  const { marketingConsentEnabled } = useCookieConsent();
  const { user } = useGlobalContext();
  const userId = user?.id;
  const userEmail = user?.email ?? null;

  useEffect(() => {
    setAdsMeasurementEnabled(marketingConsentEnabled);
    return () => setAdsMeasurementEnabled(false);
  }, [marketingConsentEnabled]);

  useEffect(() => {
    if (!marketingConsentEnabled || !pixelId) {
      return;
    }

    let active = true;
    void initializeAdsMeasurement({
      pixelId,
      debug,
      user: userId ? { id: userId, email: userEmail } : undefined,
    }).catch((error: unknown) => {
      if (active) {
        console.warn("Failed to initialize OpenAI Ads measurement", { error });
      }
    });

    return () => {
      active = false;
    };
  }, [debug, marketingConsentEnabled, pixelId, userEmail, userId]);

  return null;
}
